import React, { useEffect, useState } from "react";
import "../../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/perfomance-styles/QuestionSummary.css";
import SummaryChart from "../../../../components/question-components/charts/SummaryChart";
import axios from "axios";

const QuestionSummary = () => {
  const [userAverage, setUserAverage] = useState(0);
  const [userTotalAnswered, setUserTotalAnswered] = useState(0);
  const [allUsersAverage, setAllUsersAverage] = useState(0);
  const [histogramData, setHistogramData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSummaryData = async () => {
      setLoading(true);
      const userId = sessionStorage.getItem("userId");
      try {
        const response = await axios.get("/user/get-earliest-attempt-summary", {
          params: {
            userId: "67ebab9b5ef550de19850627",
          },
        });
        setUserAverage(response.data.userAverage);
        setUserTotalAnswered(response.data.userTotalAnswered);
        setAllUsersAverage(response.data.allUsersAverage);
        setHistogramData(response.data.histogramData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching summary data:", error);
        setError("Failed to load performance data.");
        setLoading(false);
      }
    };
    fetchSummaryData();
  }, []);

  if (loading) {
    return <div className="loading-state">Loading performance data...</div>;
  }

  if (error) {
    return <div className="error-state">Error: {error}</div>;
  }

  const userSuccessRate = userAverage ? userAverage.toFixed(1) : "0.0";
  const allUsersSuccessRate = allUsersAverage
    ? allUsersAverage.toFixed(1)
    : "0.0";
  const userProgressBarSuccess = userAverage || 0;
  const userProgressBarFailure = 100 - userAverage || 100;

  // Basic percentile calculation (can be improved with more detailed histogram data)
  let percentile = 0;
  if (histogramData.length > 0) {
    const sortedScores = [...histogramData].sort((a, b) => a - b);
    const userScore = userAverage || 0;
    let lowerCount = 0;
    for (const score of sortedScores) {
      if (score < userScore) {
        lowerCount++;
      }
    }
    percentile = Math.round((lowerCount / sortedScores.length) * 100);
  }

  // Placeholder for pass rate data - you might fetch this separately
  const aktPassRate = 73;
  const aktFailRate = 100 - aktPassRate;

  return (
    <div className="question-summary-container">
      <div className="question-summary-header">
        <h1>Performance in questions</h1>
        <p>
          Your average score is{" "}
          <span className="percentile-highlight">{userSuccessRate}%</span> after
          answering{" "}
          <span className="percentile-highlight">{userTotalAnswered}</span>{" "}
          questions. The average score of registered users is{" "}
          {allUsersSuccessRate}%.
        </p>
        <p className="question-summary-disclaimer">
          Performance data is based on the earliest attempt recorded for each
          question to try and make the comparison data as meaningful as
          possible. However, this might not perfectly represent the true "first"
          attempt if records were created out of order.
        </p>
      </div>

      <div className="histogram-section">
        <h5>Histogram of all users scores</h5>
        <hr />
        <p>
          Your score of{" "}
          <span className="percentile-highlight">{userSuccessRate}%</span> puts
          you on the{" "}
          <span className="percentile-highlight">
            {percentile}th percentile
          </span>{" "}
          of registered users. The histogram below shows the distribution of
          scores based on the earliest attempt recorded for each user on each
          question.
        </p>

        <div className="chart-container">
          <SummaryChart data={histogramData} />
        </div>

        <p className="akt-info">
          On average {aktPassRate}% of candidates passed the last AKT. The area
          shaded grey represents the {aktFailRate}% of candidates who would fail
          if this platform's data was representative of the AKT. The histogram
          and other scoring data are updated periodically.
        </p>
      </div>
    </div>
  );
};

export default QuestionSummary;
